import { Currency, DataTypeOptions } from '@core/constants/data-types.constants';
import { CurrencyAmount } from '../currency-amount.model';

export interface MonetaryAmount {
  currency: Currency;
  value: number;
}

export function monetaryAmountToCurrencyAmount(
  monetaryAmount: MonetaryAmount,
  currencies: DataTypeOptions<Currency>
): CurrencyAmount {
  const monetaryCurrency = currencies.find(c => c.value === monetaryAmount.currency)?.value;
  if (monetaryCurrency) {
    return {
      currency: monetaryCurrency,
      amount: monetaryAmount.value
    };
  }
  throw new Error(
    `Cannot convert monetaryAmount to currency amount since the specified currency (${
      monetaryAmount.currency
    }) is not found on configuration's currencies ${currencies.map(c => c.key)}`
  );
}
